module.exports = __webpack_public_path__ + "static/img/visa-card.282a9de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/visa-card.png
// module id = G0BJ
// module chunks = 20